import React, { useEffect, useRef, useState,useLayoutEffect } from "react";
import { useAppSelector, useAppDispatch } from "../../../app/hooks"
import { getPayCodeDatatableAsync, resetSelectedRecordObjectInState,deleteAllSelectedRecordPayCodeAsync, addPayCodeAsync } from "./payCodeSlice";
import PayCodeForm from "./PayCodeForm";
import PayCodeItem from "./PayCodeItem";
import { ShowSwalWithConfirmation } from '../../../common/SweetAlert';
import PayCodeOffCanvas from '../../../common/OffCanvas';
import { KTIcon } from '../../../_metronic/helpers';
import { useTranslation } from 'react-i18next';
import { CSVDownload, CSVLink } from "react-csv";
import { AccountImportExport } from "../importExport/AccountImportExport";
import CustomPagination from "../../../common/Pagination";
import { ShowToast } from '../../../common/Toastr';
import Select, { StylesConfig } from 'react-select';
import { useLocation } from 'react-router-dom';
import { updatePageIdState, getPagePermissionsAsync } from '../../../common/GlobalSlice';
import { useNavigate } from 'react-router-dom';
const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 75, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0', marginRight: '0px', fontWeight: '400px', color: '#172B4F' })
}


const PayCode = () => {

    const dispatch = useAppDispatch();
    const modelRef = useRef<any>(null);
    const { t } = useTranslation();
    const { payCodeList, isReload, selectedRecord } = useAppSelector((state) => state.payCode);
    const { pageId, menuList, IsList, IsAdd, IsEdit, IsDelete } = useAppSelector((state) => state.globalState);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const location = useLocation();
    const navigate = useNavigate();



    useLayoutEffect(() => {
        const fetchPagePermissions = async () => {
            if (pageId && pageId !== '') {
                const res = await dispatch(getPagePermissionsAsync(pageId));
                if (!res.payload.IsList) {
                    navigate('../error/403');
                }
            } else if (!pageId && menuList && menuList.length > 0) {
                const routeName = location.pathname.split('/').filter(Boolean)[0];
                const foundItem = menuList.find(item => item.SystemCategoryPageFrontEnd === routeName);
                if (foundItem) {
                    const res = await dispatch(getPagePermissionsAsync(foundItem.SystemSecurityCategoryPageId));
                    if (!res.payload.IsList) {
                        navigate('../error/403');
                    }
                } else {
                    navigate('../error/403');
                }
            }
        };

        fetchPagePermissions();
    }, [dispatch, location.pathname, menuList, navigate, pageId]);

    const handlePageChange = (pageNumber: any) => {
        setCurrentPage(pageNumber);
    };
    const handleSearch = (event: any) => {
        const { value } = event.target;
        setSearchTerm(value);
        setCurrentPage(1);
    };

    const handlePageSizeChange = (selectedOption: any) => {
        const { value, label } = selectedOption;
        setPageSize(Number(value));
        setCurrentPage(1);
    };


    const filteredData = Object.values(payCodeList).filter((item: any) => {
        const searchTermLowerCase = searchTerm.toLowerCase();
        return Object.values(item).some((value: any) => {
            if (typeof value === 'string') {
                return value.toLowerCase().includes(searchTermLowerCase);
            }
            return false;
        });
    });

    const indexOfLastItem = currentPage * pageSize;
    const indexOfFirstItem = indexOfLastItem - pageSize;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const totalItems = payCodeList.length;
    const recordsFiltered = (totalItems === filteredData.length ? 0 : currentItems.length);
    const options = [{ value: '10', label: '10' }, { value: '20', label: '20' }, { value: '30', label: '30' }, { value: '40', label: '40' }, { value: '50', label: '50' }];

    useEffect(() => {
        if (isReload) {
            dispatch(getPayCodeDatatableAsync());
        }

    }, [isReload])

    useEffect(() => {
        dispatch(getPayCodeDatatableAsync());
    }, [dispatch])

    const handleOnClickEvent = () => {
        dispatch(resetSelectedRecordObjectInState());
        setIsModalOpen(true);
    }

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const onDeleteSelectedClick = () => {
        ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
            .then((result) => {
                if (result) {
                    dispatch(deleteAllSelectedRecordPayCodeAsync(payCodeList))
                        .unwrap()
                        .then((originalPromiseResult) => {
                            ShowToast("Pay code deleted Successfully", 'Success', "success", "toast-top-right");
                        })
                        .catch((rejectedValueOrSerializedError) => {
                            ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
                        })
                }
            })
            .catch((error) => {
                console.log("ShowSwalWithConfirmation:error ", error);
            });
    }

    return (
        <>
            <div className="card card-custom admin-card">
                <div className="card-header sticky-top bg-white">
                    <h3 className="card-title fw-bold mainHeading"  >{t('Pay Code List')}</h3>
                    <div className="card-toolbar align-items-center">
                        <div className="position-relative">
                            <input
                                type="text"
                                value={searchTerm}
                                onChange={handleSearch}
                                placeholder={t('Search')}
                                className="form-control h-35px w-200px fs-7 fw-normal pr-4"
                                data-kt-user-table-filter="search"
                            />
                            <i className="ki-duotone ki-magnifier fs-5 position-absolute top-50 translate-middle-y end-0" style={{ marginRight: '10px' }}>
                                <span className="path1"></span>
                                <span className="path2"></span>
                            </i>
                        </div>
                        <div className='h-35px w-1px mx-1'></div>
                        <div className="d-flex align-items-center">
                            <Select
                                styles={colourStyles}
                                options={options}
                                value={options.find(option => parseInt(option.value) == pageSize)}
                                onChange={handlePageSizeChange}
                                className='fs-7 fw-normal'

                            />
                        </div>
                        <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        <div>
                            {(currentItems.length > 0) ? (
                                <CustomPagination
                                    currentPage={currentPage}
                                    onPageChange={handlePageChange}
                                    pageSize={pageSize}
                                    totalItems={totalItems}
                                    start={(currentPage - 1) * pageSize}
                                    t={t}
                                >
                                </CustomPagination>
                            ) : null}
                        </div>
                        {(IsAdd || (IsDelete && payCodeList.some((item: any) => item.isSelected === 1))) ? (
                            <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                        ) : null
                        }
                        {IsAdd &&
                            <button ref={modelRef} type="button"
                                className="btn btn-primary  btn-bs-btn-font-weight btn-sm"
                                onClick={handleOnClickEvent}
                                style={{ marginRight: '2px', display: payCodeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
                            >
                                {t('Add Pay Code')}
                            </button>
                        }
                        {IsDelete &&
                            <>
                                <div className="text-muted me-5" style={{ marginRight: '2px', display: payCodeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
                                    <span className="me-2" data-kt-user-table-select="selected_count">{payCodeList.filter((item: any) => item.isSelected === 1).length}</span> {t('Selected')}
                                </div>
                                <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
                                    style={{ marginRight: '2px', display: payCodeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
                                >
                                    <i className="bi bi-trash fs-5 me-2"></i>
                                    {t('Delete')}
                                </button>
                            </>
                        }
                    </div>
                </div>
                {IsList &&
                    <div className="card-body">
                        <div className="table-responsive">
                            <PayCodeItem payCodeList={currentItems} modelRef={modelRef} t={t} onopenModal={openModal} oncloseModal={closeModal} IsEdit={IsEdit} IsDelete={IsDelete} />
                        </div>
                    </div>
                }
            </div>
            {isModalOpen &&
                <PayCodeForm modelRef={modelRef} t={t} oncloseModal={closeModal} />
            }
        </>
    )
    // const dispatch = useAppDispatch();
    // const { t } = useTranslation();
    // const modelRef = useRef<any>(null);
    // const { payCodeList, isReload, selectedRecord } = useAppSelector((state) => state.payCode);
    // const [ImportedData, SetImportedData] = useState();
    // const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    // const ExportToCSV = ({ data, headers, filename } : any) => {
    //     return (
    //       <CSVLink data={data} headers={headers} filename={filename}>
    //         Export to CSV
    //       </CSVLink>
    //     );
    //   };

    // useEffect(() => {
    //     if (isReload) {
    //         dispatch(getPayCodeDatatableAsync());
    //     }
    // }, [isReload])
    // useEffect(() => {
    //     dispatch(getPayCodeDatatableAsync());
    // }, [dispatch])

    // const handleOnClickEvent = () => {
    //     dispatch(resetSelectedRecordObjectInState());
    //     //modelRef.current.click();
    // }
    // const onDeleteSelectedClick = () => {
    //     ShowSwalWithConfirmation('Are you sure you want to delete this record?', "")
    //         .then((result) => {
    //             if (result) {
                  
    //                 dispatch(deleteAllSelectedRecordPayCodeAsync(payCodeList))
    //                     .unwrap()
    //                     .then((originalPromiseResult) => {
    //                     })
    //                     .catch((rejectedValueOrSerializedError) => {
    //                         console.log('Not Delete-rejectedValueOrSerializedError', rejectedValueOrSerializedError);
    //                     })
    //             }
    //         })
    //         .catch((error) => {
    //             console.log("ShowSwalWithConfirmation:error ", error);
    //         });

    // }
   


    // const generalObject = {
    //     "name": (Object.keys(selectedRecord).length > 0 ? t('Update') : t('Add')) + t("Pay Code"),
    //     "width": "800px",
    //     "componentName": <PayCodeForm />
    //   }
    // //   const data = [
    // //     { firstName: "John", lastName: "Doe", email: "john@example.com" },
    // //     { firstName: "Alice", lastName: "Smith", email: "alice@example.com" },
    // //     // Add more data as needed
    // //   ];
    
    //   const headers = [
    //     { label: "AccountPayCodeId", key: "AccountPayCodeId" },
    //     { label: "Name", key: "Name" },
    //     { label: "Code", key: "Code" },
    //     { label: "Description", key: "Description" },
    //     { label: "IsDisabled", key: "IsDisabled" },

    //   ];

    // const handleDataLoaded = (data: any) => {
    //     // Handle the imported data, e.g., set it in the state
    //     if (data.length > 0) {
    //         SetImportedData(data);
    //         setIsButtonDisabled(false);
    //     } else {
    //         setIsButtonDisabled(true);
    //     }
    // };

    // const Import = () => {
    //     //console.log('Inserted data from import csv :',ImportedData);
    //     dispatch(addPayCodeAsync(ImportedData))
    //     .unwrap()
    //     .then((originalPromiseResult) => {
      
    //        const ResponseMessage = originalPromiseResult.ResponseMessage
    //        console.log('ResponseMessage :', ResponseMessage)
    //         ShowToast('error', ResponseMessage, "error", "toast-top-right");
    //     })
    //     .catch((rejectedValueOrSerializedError) => {
    //         ShowToast('error', rejectedValueOrSerializedError, "error", "toast-top-right");
    //     })
    // }

    // return (
    //     <>
    //         <div className="card card-custom">
    //             <div className="card-header">
    //                 <h3 className="card-title">{t('Pay Code')}</h3>
    //                 <div className="card-toolbar">
    //                     {/* <button ref={modelRef} type="button" className="btn btn-sm btn-primary" onClick={handleOnClickEvent}>
    //                         Add Payment Method
    //                     </button> */}
    //                     <a id="kt_OffCanvas" 
    //                         className='btn btn-sm btn-light-primary' 
    //                         style={{ marginRight: '2px', display: payCodeList.every((item: any) => item.isSelected === 0) ? 'none' : 'none' }}
    //                         onClick={handleOnClickEvent}>
    //                         <KTIcon iconName='exit-up' className='fs-3' />{t(`Export`)}
    //                     </a>
    //                     <a id="kt_OffCanvas" 
    //                         className='btn btn-sm btn-light-primary' 
    //                         style={{ marginRight: '2px', display: payCodeList.every((item: any) => item.isSelected === 0) ? 'block' : 'none' }}
    //                         onClick={handleOnClickEvent}>
    //                         <KTIcon iconName='plus' className='fs-3' />{t(`Add Pay Code`)}
    //                     </a>
    //                     <div className="fw-bold me-5"  style={{ marginRight: '2px', display: payCodeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}>
    //                         <span className="me-2" data-kt-user-table-select="selected_count">{payCodeList.filter((item: any) => item.isSelected === 1).length}</span> {t('Selected')}
    //                     </div>
    //                     <button type="button" className="btn btn-danger btn-sm" onClick={() => onDeleteSelectedClick()}
    //                         style={{ marginRight: '2px', display: payCodeList.some((item: any) => item.isSelected === 1) ? 'block' : 'none' }}
    //                     >
    //                         {t('Delete Selected')}
    //                     </button>
                                              

    //                 </div>
    //             </div>
    //             <div className="card-body">

    //                 <div className="table-responsive">
    //                      <PayCodeItem payCodeList={payCodeList} />
    //                 </div>
    //             </div>
    //         </div>
    //         <PayCodeOffCanvas obj={generalObject} />
    //     </>
    // )
}

export default PayCode;